import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BackendService } from '@shared/backend.service';

export interface RefreshStatus {
  isLoading: boolean;
  message: string;
  isError: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class RefreshDataService {
  private refreshStatusSubject = new Subject<RefreshStatus>();
  public refreshStatus$ = this.refreshStatusSubject.asObservable();

  constructor(private backendService: BackendService) {}

  refreshData(): Observable<any> {
    // Emit loading state
    this.refreshStatusSubject.next({
      isLoading: true,
      message: 'Refreshing data...',
      isError: false,
    });

    return new Observable((observer) => {
      this.backendService.refreshData().subscribe({
        next: (response: any) => {
          // Emit success state
          this.refreshStatusSubject.next({
            isLoading: false,
            message: response?.message || 'Data refreshed successfully',
            isError: false,
          });
          observer.next(response);
          observer.complete();
        },
        error: (error: any) => {
          // Emit error state
          this.refreshStatusSubject.next({
            isLoading: false,
            message: error?.message || 'Failed to refresh data',
            isError: true,
          });
          observer.error(error);
        },
      });
    });
  }
}
